import {all, fork} from 'redux-saga/effects';
import usersSaga from './actions/users';
import hubSaga from './actions/hub';
import assetsSaga from './actions/assets';
import streamsSaga from './actions/streams';
import streamAccessControllerSaga from './actions/streamAccessController';
import groupsSaga from './actions/groups';
import customFieldsSaga from './actions/customFields';
import collectionsSaga from './actions/collections';
import searchSaga from './actions/search';
import dataSourceSaga from './actions/dataSource';
import entitiesSaga from './actions/entities';
import accountsSaga from './actions/accounts';
import contentMapSaga from './actions/contentMap';
import mediaLibrarySaga from './actions/mediaLibrary';
import mediaSaga from './actions/media';
import microsoftWopiIntegrationSaga from './actions/microsoftWopiIntegration';
import gDocIntegrationSaga from './actions/gdocIntegration';
import linkSaga from './actions/link';
import notificationSaga from './actions/notifications';
import seekSaga from './actions/seek';
import dealRoomsSaga from './actions/dealRoom';
import conversationsSaga from './actions/conversation';
import backgroundTaskSaga from './actions/backgroundTask';
import cleverStorySaga from './actions/cleverstory';
import adoptionSaga from './actions/adoption';
import coursesSaga from './actions/coaching/courses';
import contactSaga from './actions/contact';
import organizationSaga from './actions/organization';
import opportunitiesSaga from './actions/opportunities';
import linkedInIntegrationSaga from './actions/integrations/linkedIn';
import shareTemplatesSaga from './actions/shareTemplates';
import learnersSaga from './actions/coaching/learners';
import skillsSagas from './actions/coaching/settings';
import emailTemplatesSaga from './actions/emailTemplates';
import ndaSaga from './actions/ndaTemplate';
import simulationSaga from './actions/simulation/simulations';
import scenariosSaga from './actions/simulation/scenarios';
import callSimulationSaga from './actions/coaching/simulation';
import coachingReportsSaga from './actions/coaching/reports';
import referralInfoSaga from './actions/referral';
import exploreSaga from './actions/coaching/explore';
import podcastsSaga from './actions/coaching/podcast';
import studioSaga from './actions/coaching/studio';
import reportsSaga from './actions/reports';
import callRecordingSaga from './actions/coaching/callRecording';
import microLearningSaga from './actions/coaching/microLearning';
import hubspotIntegrationSaga from './actions/integrations/hubspot';
import callMeetingSaga from './actions/coaching/callLibrary';
import gamificationSaga from './actions/coaching/gamification';
import workspacesSaga from './actions/experiences/workspaces';
import storyboardListsSaga from './actions/experiences/storyboardLists';

export default function* root() {
  yield all([
    fork(usersSaga),
    fork(accountsSaga),
    fork(hubSaga),
    fork(backgroundTaskSaga),
    fork(assetsSaga),
    fork(groupsSaga),
    fork(workspacesSaga),
    fork(storyboardListsSaga),
    fork(streamsSaga),
    fork(streamAccessControllerSaga),
    fork(collectionsSaga),
    fork(searchSaga),
    fork(dataSourceSaga),
    fork(entitiesSaga),
    fork(customFieldsSaga),
    fork(contentMapSaga),
    fork(mediaLibrarySaga),
    fork(mediaSaga),
    fork(microsoftWopiIntegrationSaga),
    fork(gDocIntegrationSaga),
    fork(linkSaga),
    fork(notificationSaga),
    fork(seekSaga),
    fork(dealRoomsSaga),
    fork(conversationsSaga),
    fork(cleverStorySaga),
    fork(adoptionSaga),
    fork(coursesSaga),
    fork(contactSaga),
    fork(organizationSaga),
    fork(opportunitiesSaga),
    fork(linkedInIntegrationSaga),
    fork(shareTemplatesSaga),
    fork(learnersSaga),
    fork(skillsSagas),
    fork(emailTemplatesSaga),
    fork(ndaSaga),
    fork(scenariosSaga),
    fork(simulationSaga),
    fork(coachingReportsSaga),
    fork(callSimulationSaga),
    fork(referralInfoSaga),
    fork(exploreSaga),
    fork(reportsSaga),
    fork(podcastsSaga),
    fork(studioSaga),
    fork(callRecordingSaga),
    fork(microLearningSaga),
    fork(hubspotIntegrationSaga),
    fork(callMeetingSaga),
    fork(gamificationSaga),
  ]);
}
